<template>
	<div class="modal is-active">
		<div class="modal-background" @click="cancel"></div>
		<div class="modal-card showmap">
			<header class="modal-card-head">
				<p class="buildingName">
					Byggnad: {{ flaw.map.floor.buildingName }} , Våning:
					{{ flaw.map.floor.name }} , Ritning: {{ flaw.map.name }}
				</p>
				<button class="delete" aria-label="close" @click="cancel"></button>
			</header>
			<section class="modal-card-body no-scroll" id="dropZone">
				<img
					:src="mapImg"
					alt=""
					class="image-container"
					@load="updateRatio"
					:draggable="false"
				/>
				<Itemcomponent
					:items="[flaw]"
					:areaWidthRatio="areaWidthRatio"
					:areaHeightRatio="areaHeightRatio"
					:disable="true"
				/>
			</section>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Itemcomponent from '@/views/floors/components/ItemComponent.vue';
export default {
	components: {
		Itemcomponent
	},
	props: {
		flaw: {
			type: Object,
			default: () => ({})
		},
		mapImg: {
			type: String,
			default: ''
		}
	},
	data: () => ({
		areaWidthRatio: 1,
		areaHeightRatio: 1
	}),
	computed: {
		...mapState('fileStore', {
			fileState: state => state
		}),
		...mapState('mapStore', ['map'])
	},
	methods: {
		...mapActions('fileStore', ['getFile']),
		...mapActions('mapStore', ['getMap']),
		cancel() {
			this.$emit('cancel');
		},
		updateRatio() {
			let dropzone = document.getElementById('dropZone');

			if (dropzone) {
				this.areaWidthRatio = dropzone.offsetWidth / 1000;
				this.areaHeightRatio = dropzone.offsetHeight / 1000;
			}
		}
	},
	created() {
		this.flaw.scale = 2;
		window.addEventListener('resize', this.updateRatio);
	}
};
</script>
<style lang="scss" scoped>
.showmap {
  .modal-card-head {
    background-color: #fff !important;
    padding: 1px;
    button {
      margin-left: auto;
      z-index: 1000;
    }

    .buildingName {
      color: #000 !important;
    }
  }

  .modal-card-body {
    img {
      width: 100%;
    }
  }
}
</style>
